var _slicedToArray = require("/usr/local/micropublication/micropub-public/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _defineProperty = require("/usr/local/micropublication/micropub-public/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var $VjlY2$react = require("react");

var $VjlY2$proptypes = require("prop-types");

var $VjlY2$dompurify = require("dompurify");

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {
    value: true,
    configurable: true
  });
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () {
  return $366f189997649a4c$export$2e2bcd8739ae039;
});
var $366f189997649a4c$var$baseConfig = {
  showMathMenu: true,
  tex2jax: {
    inlineMath: [["$", "$"], ["\\(", "\\)"]]
  },
  skipStartupTypeset: true
};
var $366f189997649a4c$var$defaultSanitizeOptions = {
  USE_PROFILES: {
    mathMl: true
  },
  ADD_ATTR: ['columnalign']
};
var $366f189997649a4c$var$MathJaxPreview = /*#__PURE__*/$parcel$interopDefault($VjlY2$react).forwardRef(function (_ref, ref) {
  var script = _ref.script,
      config = _ref.config,
      className = _ref.className,
      math = _ref.math,
      id = _ref.id,
      style = _ref.style,
      wrapperTag = _ref.wrapperTag,
      msDelayDisplay = _ref.msDelayDisplay,
      onDisplay = _ref.onDisplay,
      onLoad = _ref.onLoad,
      onError = _ref.onError,
      sanitizeOptions = _ref.sanitizeOptions;
  var sanitizedMath = $parcel$interopDefault($VjlY2$dompurify).sanitize(math, _objectSpread(_objectSpread({}, $366f189997649a4c$var$defaultSanitizeOptions), sanitizeOptions));
  var previewRef = $VjlY2$react.useRef();

  var _$VjlY2$react$useStat = $VjlY2$react.useState("none"),
      _$VjlY2$react$useStat2 = _slicedToArray(_$VjlY2$react$useStat, 2),
      display = _$VjlY2$react$useStat2[0],
      setDisplay = _$VjlY2$react$useStat2[1]; //prevent display during processing


  var _$VjlY2$react$useStat3 = $VjlY2$react.useState(window.MathJax ? "loaded" : "loading"),
      _$VjlY2$react$useStat4 = _slicedToArray(_$VjlY2$react$useStat3, 2),
      loadingState = _$VjlY2$react$useStat4[0],
      setLoadingState = _$VjlY2$react$useStat4[1];

  $VjlY2$react.useEffect(function () {
    var mathjaxScriptTag = document.querySelector("script[src=\"".concat(script, "\"]"));

    if (!mathjaxScriptTag) {
      mathjaxScriptTag = document.createElement("script");
      mathjaxScriptTag.async = true;
      mathjaxScriptTag.src = script;

      for (var _i = 0, _Object$entries = Object.entries(config || {}); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            k = _Object$entries$_i[0],
            v = _Object$entries$_i[1];

        mathjaxScriptTag.setAttribute(k, v);
      }

      var node = document.head || document.getElementsByTagName("head")[0];
      node.appendChild(mathjaxScriptTag);
    }

    var onloadHandler = function onloadHandler() {
      setLoadingState("loaded");
      window.MathJax.Hub.Config(_objectSpread(_objectSpread({}, $366f189997649a4c$var$baseConfig), config));
      onLoad && onLoad();
    };

    var onerrorHandler = function onerrorHandler() {
      setLoadingState("failed");
      onError && onError();
    };

    mathjaxScriptTag.addEventListener("load", onloadHandler);
    mathjaxScriptTag.addEventListener("error", onerrorHandler);
    return function () {
      mathjaxScriptTag.removeEventListener("load", onloadHandler);
      mathjaxScriptTag.removeEventListener("error", onloadHandler);
    };
  }, [setLoadingState, config, $366f189997649a4c$var$baseConfig]);
  $VjlY2$react.useEffect(function () {
    if (loadingState !== "loaded") return;
    previewRef.current.innerHTML = sanitizedMath;
    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, previewRef.current]); //delay display of div

    var msDelay;
    if (msDelayDisplay !== null && !isNaN(+msDelayDisplay) && +msDelayDisplay >= 0 && +msDelayDisplay < 10000) msDelay = +msDelayDisplay;else msDelay = 300; // default 300ms delay

    var timeout = setTimeout(function () {
      setDisplay("inline"); //display div after delay, hopefully typeset has finished

      onDisplay && onDisplay();
    }, msDelay);
    return function () {
      setDisplay("none");
      clearTimeout(timeout);
    };
  }, [sanitizedMath, loadingState, previewRef]);
  return /*#__PURE__*/$parcel$interopDefault($VjlY2$react).createElement(wrapperTag, {
    className: className,
    id: id,
    style: _objectSpread({
      display: display
    }, style),
    ref: ref
  }, /*#__PURE__*/$parcel$interopDefault($VjlY2$react).createElement($parcel$interopDefault($VjlY2$react).Fragment, null, loadingState === "failed" && /*#__PURE__*/$parcel$interopDefault($VjlY2$react).createElement("span", null, "fail loading mathjax lib"), /*#__PURE__*/$parcel$interopDefault($VjlY2$react).createElement(wrapperTag, {
    className: "react-mathjax-preview-result",
    ref: previewRef
  })));
});
$366f189997649a4c$var$MathJaxPreview.displayName = 'MathJaxPreview';
$366f189997649a4c$var$MathJaxPreview.propTypes = {
  script: $parcel$interopDefault($VjlY2$proptypes).string,
  config: $parcel$interopDefault($VjlY2$proptypes).object,
  className: $parcel$interopDefault($VjlY2$proptypes).string,
  math: $parcel$interopDefault($VjlY2$proptypes).string,
  style: $parcel$interopDefault($VjlY2$proptypes).object,
  wrapperTag: $parcel$interopDefault($VjlY2$proptypes).string,
  id: $parcel$interopDefault($VjlY2$proptypes).string,
  onLoad: $parcel$interopDefault($VjlY2$proptypes).func,
  onError: $parcel$interopDefault($VjlY2$proptypes).func,
  onDisplay: $parcel$interopDefault($VjlY2$proptypes).func,
  sanitizeOptions: $parcel$interopDefault($VjlY2$proptypes).object
};
$366f189997649a4c$var$MathJaxPreview.defaultProps = {
  script: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.6/MathJax.js?config=TeX-MML-AM_HTMLorMML",
  id: "react-mathjax-preview",
  sanitizeOptions: {},
  wrapperTag: "div"
};
var $366f189997649a4c$export$2e2bcd8739ae039 = $366f189997649a4c$var$MathJaxPreview;